import { useEffect, useRef, useState } from 'react';
import { ETestIds } from '../../../../constants/testIds';
import { EScrollUpButtonType } from '../types';
import { getDataTestIdByType, getIconByType } from '../utils';

export const useScrollUpButton = () => {
  const [type, setType] = useState<EScrollUpButtonType>(EScrollUpButtonType.Filters);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const icon = getIconByType(type);
  const testId = getDataTestIdByType(type);

  const scrollTo = (testId: string) => () => {
    const calculator = document.querySelector(`[data-testid=${testId}]`) as Element;
    calculator?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const offerList = document.querySelector(`[data-testid=${ETestIds.OfferList}]`) as Element;
    if (!offerList) {
      return;
    }

    const scrollUpButtonObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setType(EScrollUpButtonType.Filters);
          } else {
            setType(EScrollUpButtonType.Up);
          }
        });
      },
      {
        threshold: 0.01,
      },
    );

    scrollUpButtonObserver.observe(offerList);

    return () => {
      scrollUpButtonObserver.disconnect();
    };
  });

  return {
    type,
    buttonRef,
    icon,
    scrollToBlock: scrollTo(testId),
  };
};
